export const items = [
  {
    id: Math.random(),
    title: "Breackfast",
    description: "Breakfast meal Breakfast meal ",
    catogory: "Breakfast",
    price: "40 ",
    img: "/img/2.jpeg",
  },
  {
    id: Math.random(),
    title: "Breackfast",
    description: "Breakfast meal Breakfast meal ",
    catogory: "Breakfast",
    price: "50 ",
    img: "/img/b2.jpg",
  },
  {
    id: Math.random(),
    title: "Dinner",
    description: "lunch meal Dinner meal ",
    catogory: "Dinner",
    price: "80 ",
    img: "/img/d1.jpg",
  },
  {
    id: Math.random(),
    title: "Dinner",
    description: "Dinner meal Dinner meal ",
    catogory: "Dinner",
    price: "90 ",
    img: "/img/d2.jpg",
  },
  {
    id: Math.random(),
    title: "Lunch",
    description: "lunch meal lunch meal ",
    catogory: "Lunch",
    price: "60 ",
    img: "/img/l1.jpg",
  },
  {
    id: Math.random(),
    title: "Lunch",
    description: "lunch meal lunch meal ",
    catogory: "Lunch",
    price: "70 ",
    img: "/img/l2.jpg",
  },
];
